import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DisplayItem from '../DisplayItem';

export function MantelAndScrapComponent({ mantel, scrapbook }) {
  return (
    <div className="profile__mantel-and-scrap">
      {mantel && <DisplayItem data={mantel} label="Mantelpiece" nature="Thing" />}
      {scrapbook && <DisplayItem data={scrapbook} label="Scrapbook" nature="Status" />}
    </div>
  );
}

MantelAndScrapComponent.propTypes = {
  mantel: PropTypes.shape({}),
  scrapbook: PropTypes.shape({}),
};

MantelAndScrapComponent.defaultProps = {
  mantel: undefined,
  scrapbook: undefined,
};

const mapStateToProps = ({
  profile: {
    profileCharacter: {
      mantelpieceItem: mantel,
      scrapbookStatus: scrapbook,
    },
  },
}) => ({
  mantel,
  scrapbook,
});

export default connect(mapStateToProps)(MantelAndScrapComponent);